<template>
  <div class="modal fade" id="add-product-modal">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down">
      <div class="modal-content border-0">
        <div class="modal-header border-0 pb-0">
           <div class="d-flex align-items-center gap-3">
              <button type="button" class="btn-close-mob d-md-none" data-bs-dismiss="modal">
                 <vue-feather type="x" size="20"></vue-feather>
              </button>
              <h5 class="fw-bold mb-0">Tambah Produk Baru</h5>
           </div>
           <button type="button" class="btn-close d-none d-md-block" data-bs-dismiss="modal" ref="closeBtn"></button>
        </div>
        <div class="modal-body p-4">
           <form @submit.prevent="handleSubmit">
              <div class="mb-4">
                 <label class="form-label">Nama Produk</label>
                 <input type="text" v-model="form.nama_produk" class="form-control" placeholder="Masukkan nama produk" required />
              </div>
              <div class="mb-4">
                 <label class="form-label">Status</label>
                 <vue-select
                    :options="statusOptions"
                    v-model="form.status"
                    id="add-product-status"
                    placeholder="Pilih Status"
                 />
              </div>
              <div class="d-grid mt-4">
                 <button type="submit" class="btn btn-success rounded-pill py-3 fw-bold shadow-sm" :disabled="loading">
                    {{ loading ? 'MENYIMPAN...' : 'TAMBAH PRODUK' }}
                 </button>
              </div>
           </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn-close-mob {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.form-label {
    font-size: 11px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.form-control {
    border: 1px solid #f1f5f9;
    background: #f8fafc;
    border-radius: 12px;
    padding: 14px 16px;
    font-size: 14px;
}
.form-control:focus {
    border-color: #029147;
    background: white;
    box-shadow: none;
}
</style>

<script>
import { reactive, ref } from 'vue';
import productService from '@/services/productService';
import { useDataStore } from '@/store/dataStore';
import Swal from 'sweetalert2';

export default {
  setup() {
    const { refreshData } = useDataStore();
    const loading = ref(false);
    const closeBtn = ref(null);
    
    const form = reactive({
      nama_produk: '',
      status: 'active'
    });

    const statusOptions = [
      { id: 'active', text: 'Aktif' },
      { id: 'inactive', text: 'Non-Aktif' }
    ];

    const handleSubmit = async () => {
      loading.value = true;
      try {
        await productService.createProduct({
          nama_produk: form.nama_produk,
          status: form.status
        });

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });

        Toast.fire({
          icon: 'success',
          title: 'Produk berhasil ditambahkan'
        });

        // Reset form
        form.nama_produk = '';
        form.status = 'active';

        // Update global store
        await refreshData('products');
        
        // Close modal
        if (closeBtn.value) {
          closeBtn.value.click();
        }
      } catch (error) {
        console.error("Create error:", error);
        Swal.fire({
          icon: 'error',
          title: 'Gagal menambahkan produk'
        });
      } finally {
        loading.value = false;
      }
    };

    return {
      form,
      statusOptions,
      loading,
      handleSubmit,
      closeBtn
    };
  }
};
</script>
